import type { ErrorPageContentProps } from '../ErrorPageContent/ErrorPageContent';
import { ErrorPageContent } from '../ErrorPageContent/ErrorPageContent';

export const FullPageContent = (props: Exclude<ErrorPageContentProps, 'errorCode'>) => {
  return <ErrorPageContent {...props} />;
};
